import React from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import classes from "./StockTransferReportSummary.module.css";

const StockTransferReportSummary = ({
  refreshData = () => {},
  refreshRef,
  quickExport = () => {},
  exportRef,
}) => {
  return (
    <div className={classes["summary-container"]}>
      <div className={classes["summary-ctas"]}>
        <FilterGroup>
          <FilterItem>
            <Button
              label="Quick Export"
              color="black"
              endIcon={<Shortcut keys={["Alt", "E"]} />}
              onClick={quickExport}
              isAccessible={true}
              ref={exportRef}
            />
          </FilterItem>
          <FilterItem>
            <Button
              ref={refreshRef}
              label="Refresh"
              color="black"
              onClick={() => {
                refreshData();
              }}
              endIcon={<Shortcut keys={["Alt", "R"]} />}
            />
          </FilterItem>
        </FilterGroup>
      </div>
    </div>
  );
};

export default StockTransferReportSummary;
